var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaveinspectionpreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#6D7D8B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6252 23.0413H21.3752C22.2957 23.0413 23.0418 22.2952 23.0418 21.3747V15.19C23.0418 14.748 22.8662 14.3241 22.5537 14.0115L19.9883 11.4462C19.6757 11.1336 19.2518 10.958 18.8098 10.958H12.6252C11.7047 10.958 10.9585 11.7042 10.9585 12.6247V21.3747C10.9585 22.2952 11.7047 23.0413 12.6252 23.0413Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2915 22.8337V20.1253C14.2915 19.6651 14.6646 19.292 15.1248 19.292H18.8748C19.3351 19.292 19.7082 19.6651 19.7082 20.1253V22.8337",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2915 11.167V13.8753",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveinspectionpreview);
export default __webpack_public_path__ + "static/media/saveinspectionpreview.e838f708.svg";
export { ForwardRef as ReactComponent };